import React from 'react';
import theme from 'theme';
import { Colors, Text, Highlight, LoadingIndicator } from 'library';
import { Grid, styled, useMediaQuery } from '@mui/material';

import PublicTeacherCard from './PublicTeacherCard';

import { ITeacher } from 'models/Providers/Teacher';
import ZipSearch from './ZipSearch';
import NoWorkersFound from './NoWorkersFound';
import SuccessMessage from './SuccessMessage';
import { SeeMoreTeachers } from './SeeMoreTeachers';
import StaffFilter, { StaffFilterOptions } from './StaffFilter';
import ThreeColumnCardGrid from 'parent-portal/providers/cards/shared/ThreeColumnCardGrid';

export function StaffNearYou({
    signUp,
    zipCode,
    searchedZipCode,
    updateZipCode,
    onSearch,
    loading,
    workers,
    vettedWorkersCount,
    filters,
}: {
    signUp: () => void;
    zipCode: string;
    searchedZipCode: string;
    updateZipCode: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSearch: (filters: StaffFilterOptions) => void;
    loading: boolean;
    workers?: ITeacher[];
    vettedWorkersCount: number;
    filters: StaffFilterOptions;
}) {
    const smDown = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Container container item flexDirection="row" xs={12}>
            <InteriorContainer smDown={smDown.toString()} item container flexDirection="column" xs={12} md={12}>
                <SubContainer
                    smDown={smDown.toString()}
                    item
                    container
                    xs={12}
                    flexDirection="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid>
                        <Text variant="display" bold>
                            <Highlight color={Colors.mediumTurq}>Available Teachers Near {searchedZipCode}</Highlight>
                        </Text>
                    </Grid>
                    <HorizontalDiv>
                        <ZipSearch zipCode={zipCode} updateZipCode={updateZipCode} search={onSearch} />
                        <StaffFilter filters={filters} search={onSearch} />
                    </HorizontalDiv>
                </SubContainer>
                <SuccessMessage visible={!loading && !!workers && workers.length > 0} />
                {loading && <LoadingIndicator />}
                {!loading && (!workers || workers.length === 0) && <NoWorkersFound signUp={signUp} />}

                <Grid
                    container
                    xs={12}
                    style={{
                        minHeight: 600,
                        marginTop: 20,
                        marginBottom: 20,
                    }}
                >
                    {!loading && !!workers && (
                        <>
                            <ThreeColumnCardGrid
                                renderItem={(worker) => <PublicTeacherCard worker={worker} />}
                                items={workers}
                            />
                            {workers.length > 0 && (
                                <SeeMoreTeachers signUp={signUp} vettedWorkersCount={vettedWorkersCount} />
                            )}
                        </>
                    )}
                </Grid>
            </InteriorContainer>
        </Container>
    );
}

const Container = styled(Grid)({
    height: 'fit-content',
});

const SubContainer = styled(Container)(({ smDown }: { smDown: string }) => ({
    marginTop: smDown === 'true' ? '6%' : '2%',
    marginBottom: smDown === 'true' ? 10 : 0,
    gap: smDown === 'true' ? 10 : 0,
}));

const InteriorContainer = styled(SubContainer)({
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.mediumGrey}`,
    borderRadius: 18,
    padding: '20px 30px 20px 30px',
    marginBottom: 30,
});

const HorizontalDiv = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    alignItems: 'flex-end',
    flexWrap: 'wrap',
});
